import * as React from "react";

interface DragAndDropIconProps {
    className?: string;
    onClick?: () => void;
}

export function DragAndDropIcon(props: DragAndDropIconProps) {
    return (
        <div {...props}>
            <svg
                width="41"
                height="40"
                viewBox="0 0 41 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect x="0.5" width="40" height="40" rx="8" fill="white" />
                <g clipPath="url(#clip0_8625_30212)">
                    <path
                        d="M21.75 23.9996H19.25C18.8344 23.9996 18.5 23.6652 18.5 23.2496V17.9996H15.7594C15.2031 17.9996 14.925 17.3277 15.3187 16.934L20.0719 12.1777C20.3063 11.9434 20.6906 11.9434 20.925 12.1777L25.6812 16.934C26.075 17.3277 25.7969 17.9996 25.2406 17.9996H22.5V23.2496C22.5 23.6652 22.1656 23.9996 21.75 23.9996ZM28.5 23.7496V27.2496C28.5 27.6652 28.1656 27.9996 27.75 27.9996H13.25C12.8344 27.9996 12.5 27.6652 12.5 27.2496V23.7496C12.5 23.334 12.8344 22.9996 13.25 22.9996H17.5V23.2496C17.5 24.2152 18.2844 24.9996 19.25 24.9996H21.75C22.7156 24.9996 23.5 24.2152 23.5 23.2496V22.9996H27.75C28.1656 22.9996 28.5 23.334 28.5 23.7496ZM24.625 26.4996C24.625 26.1559 24.3438 25.8746 24 25.8746C23.6562 25.8746 23.375 26.1559 23.375 26.4996C23.375 26.8434 23.6562 27.1246 24 27.1246C24.3438 27.1246 24.625 26.8434 24.625 26.4996ZM26.625 26.4996C26.625 26.1559 26.3438 25.8746 26 25.8746C25.6562 25.8746 25.375 26.1559 25.375 26.4996C25.375 26.8434 25.6562 27.1246 26 27.1246C26.3438 27.1246 26.625 26.8434 26.625 26.4996Z"
                        fill="#333333"
                    />
                    <path
                        d="M21.75 23.9996H19.25C18.8344 23.9996 18.5 23.6652 18.5 23.2496V17.9996H15.7594C15.2031 17.9996 14.925 17.3277 15.3187 16.934L20.0719 12.1777C20.3063 11.9434 20.6906 11.9434 20.925 12.1777L25.6812 16.934C26.075 17.3277 25.7969 17.9996 25.2406 17.9996H22.5V23.2496C22.5 23.6652 22.1656 23.9996 21.75 23.9996ZM28.5 23.7496V27.2496C28.5 27.6652 28.1656 27.9996 27.75 27.9996H13.25C12.8344 27.9996 12.5 27.6652 12.5 27.2496V23.7496C12.5 23.334 12.8344 22.9996 13.25 22.9996H17.5V23.2496C17.5 24.2152 18.2844 24.9996 19.25 24.9996H21.75C22.7156 24.9996 23.5 24.2152 23.5 23.2496V22.9996H27.75C28.1656 22.9996 28.5 23.334 28.5 23.7496ZM24.625 26.4996C24.625 26.1559 24.3438 25.8746 24 25.8746C23.6562 25.8746 23.375 26.1559 23.375 26.4996C23.375 26.8434 23.6562 27.1246 24 27.1246C24.3438 27.1246 24.625 26.8434 24.625 26.4996ZM26.625 26.4996C26.625 26.1559 26.3438 25.8746 26 25.8746C25.6562 25.8746 25.375 26.1559 25.375 26.4996C25.375 26.8434 25.6562 27.1246 26 27.1246C26.3438 27.1246 26.625 26.8434 26.625 26.4996Z"
                        fill="white"
                        fillOpacity="0.25"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_8625_30212">
                        <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(12.5 12)"
                        />
                    </clipPath>
                </defs>
            </svg>
        </div>
    );
}
